<div
  [ngClass]="{ tall: isTall }"
  class="audit-detail-list"
  infiniteScroll
  [infiniteScrollDistance]="0.5"
  [infiniteScrollContainer]="'.audit-detail-list'"
  [fromRoot]="true"
  [scrollWindow]="false"
  [alwaysCallback]="true"
  (scrolled)="nextPage.emit()"
>
  <div *ngIf="loading">Loading...</div>
  <div *ngIf="loaded">
    <div *ngIf="audits && audits.length > 0; else noAudits">
      <div *ngFor="let audit of audits">
        <sd-portal-audit-detail [audit]="audit"></sd-portal-audit-detail>
      </div>
    </div>
    <ng-template #noAudits> {{ noAuditsMessage }} </ng-template>
  </div>
</div>
